import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container, Row, Col} from 'react-bootstrap'
import MenuAdmin from '../components/menus/MenuAdmin'
import Dashboard from '../pages/admin/Dashboard'
import CandidateProfile from '../pages/admin/CandidateProfile'
import SchoolProfile from '../pages/admin/SchoolProfile'
import { Footer } from '../components/footers/Footer'
import Candidates from '../pages/admin/Candidates'
import Schools from '../pages/admin/Schools'
import ProcessAdmin from '../pages/admin/ProcessAdmin'
import OfficialTitles from '../pages/candidate/OfficialTitles'
import Courses from '../pages/candidate/Courses'
import CareerPath from '../pages/candidate/CareerPath'
import Competences from '../pages/candidate/Competences'
import Technologies from '../pages/candidate/Technologies'
import Methodologies from '../pages/candidate/Methodologies'
import Languages from '../pages/candidate/Languages'
import IdealPosition from '../pages/candidate/IdealPosition'
import Profile from '../pages/candidate/Profile'
import EditSelection from '../pages/admin/EditSelection'
import CreateSchool from '../pages/admin/CreateSchool'
import CreateCandidate from '../pages/admin/CreateCandidate'
import MultiSchools from '../pages/admin/MultiSchools'
import CreateMultiSchool from '../pages/admin/CreateMultiSchool'
import EditMultiSchool from '../pages/admin/EditMultiSchool'

export default function AdminRouter () {
	return (
		<Container className='d-flex contenedor'>
			<div className='menu-lateral d-none d-sm-block'>
				<MenuAdmin/>
			</div>
			<div className='contenido'>
				<Row>
					<Col>

					</Col>
				</Row>
				<Row>
					<Col>
						<Routes>
							<Route path="/dashboard" element={<Dashboard/>}/>
							<Route path="/candidates" element={<Candidates/>}/>
							<Route path="/candidates/new" element={<CreateCandidate/>}/>
							<Route path="/candidate/profile/:id" element={<Profile/>}/>
							<Route path="/candidate/officialtitles/:id" element={<OfficialTitles/>}/>
							<Route path="/candidate/courses/:id" element={<Courses/>}/>
							<Route path="/candidate/careerpath/:id" element={<CareerPath/>}/>
							<Route path='/candidate/competences/:id' element={<Competences/>}/>
							<Route path='/candidate/technologies/:id' element={<Technologies/>}/>
							<Route path='/candidate/methodologies/:id' element={<Methodologies/>}/>
							<Route path='/candidate/languages/:id' element={<Languages/>}/>
							<Route path='/candidate/ideal-position/:id' element={<IdealPosition/>}/>
							<Route path="/schools" element={<Schools/>}/>
							<Route path="/candidateprofile/:id" element={<CandidateProfile/>}/>
							<Route path="/schoolprofile/:id" element={<SchoolProfile/>}/>
							<Route path="/schools/new" element={<CreateSchool/>}/>
							<Route path="/activeprocesses" element={<ProcessAdmin />}/>
							<Route path="/activeprocesses/:id" element={<ProcessAdmin />}/>
							<Route path="/completedprocesses" element={<ProcessAdmin active={false}/>}/>
							<Route path="/completedprocesses/:id" element={<ProcessAdmin active={false}/>}/>
							<Route path="/editprocess/:id" element={<EditSelection />}/>
							<Route path="/multischools" element={<MultiSchools/>}/>
							<Route path="/multischools/new" element={<CreateMultiSchool/>}/>
							<Route path="/multischools/edit/:id" element={<EditMultiSchool/>}/>
							<Route path="*" element={<NotFoundPage />}/>
						</Routes>
					</Col>
				</Row>
				<Row>
					<Col>
						<Footer/>
					</Col>
				</Row>
			</div>
		</Container>
	)
}